import SolidFoodForm from "../../components/forms/solidFoodForm";
import SolidFoodTable from "../../components/tables/solidFoodTable";
import LoadingState from "../../components/ui/LoadingState";
import EmptyState from "../../components/ui/EmptyState";
import { useFirestore } from "../../hooks/useFirestore";
import { useChild } from "../../contexts/ChildContext";
import { exportToCSV, solidFoodCSVColumns } from "../../utils/exportUtils";
import { exportSectionPDF } from "../../utils/pdfUtils";

const SolidFoods = (() => {
    const { selectedChild } = useChild();
    const { items: solidFoods, addItem, updateItem, deleteItem, loading, error } = useFirestore("solidFoods", selectedChild?.id);

    const handleAddFood = async (food) => {
        try {
            await addItem({ ...food, childId: selectedChild?.id });
        } catch (err) {
            console.error("Error adding solid food:", err);
        }
    };

    const handleExport = () => {
        exportToCSV(solidFoods, `solid-foods-${selectedChild?.name || "export"}.csv`, solidFoodCSVColumns);
    };

    const handleExportPDF = () => {
        exportSectionPDF(solidFoods, `solid-foods-${selectedChild?.name || "export"}.pdf`, solidFoodCSVColumns, "Solid Foods", selectedChild?.name || "");
    };

    return (
        <div className="card h-100" id="solid-foods">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title mb-0">🥘 Solid Foods</h5>
                    <div className="d-flex gap-1">
                        <button className="btn btn-sm btn-outline-secondary" onClick={handleExport}>⬇ CSV</button>
                        <button className="btn btn-sm btn-outline-primary" onClick={handleExportPDF}>⬇ PDF</button>
                    </div>
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                <SolidFoodForm onAdd={handleAddFood} />
                {loading ? (
                    <LoadingState message="Loading solid foods..." />
                ) : solidFoods.length > 0 ? (
                    <SolidFoodTable data={solidFoods} onUpdate={updateItem} onDelete={deleteItem} />
                ) : (
                    <EmptyState
            icon="🥘"
            heading="No solid foods logged yet"
            message="Record those first tastes and discover what your little one loves."
          />
                )}
            </div>
        </div>
    )
});

export default SolidFoods;
